import clsx from 'clsx';

interface ElectronicInvoicingStatusProps {
  associated: boolean;
}

function ElectronicInvoicingStatus({ associated }: ElectronicInvoicingStatusProps) {
  return (
    <div
      className={clsx('electronic-invoicing-status-badge', {
        associated,
        'not-associated': !associated,
      })}
    >
      {associated ? 'Asociado' : 'No asociado'}
    </div>
  );
}

export default ElectronicInvoicingStatus;

